import {ClimbigEventType, ClimbingEvent, ClimbingEventGroup, FOR_ALL} from "./ClimbingEvent"
import {Sex} from "./UserData"
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import BoltIcon from '@mui/icons-material/Bolt';
import {ComponentType} from "react";
import {SvgIconProps} from "@mui/material";
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import LooksOneIcon from '@mui/icons-material/LooksOne';

export enum UserRouteStatus {
    NOTHING = "NOTHING",
    FLASH = "FLASH",
    DONE = "DONE",
    LATER = "LATER",
    ZONE = "ZONE",
    ZONE2 = "ZONE2",
}

export const isDone = (status?: UserRouteStatus): boolean => status === UserRouteStatus.DONE || status === UserRouteStatus.FLASH

export enum DifficultyCategory {
    LIGHT = "LIGHT"
}

export const DifficultyCategoryLabel: { [key in DifficultyCategory]: string } = {
    [DifficultyCategory.LIGHT]: "LIGHT"
};

export type StatusLabelAndColour = {
    status: UserRouteStatus,
    label: string,
    color: string,
    icon: ComponentType<SvgIconProps>

}

export const getAllUserRouteStatus = (event: ClimbingEvent): StatusLabelAndColour[] => {
    const type = event.type
    const flash = type === ClimbigEventType.FLASH || type === ClimbigEventType.FLASH_ZONE || (type === ClimbigEventType.CUSTOM && !!event.flashPoints)
    const zone = type === ClimbigEventType.FLASH_ZONE || (type === ClimbigEventType.CUSTOM && !!event.zonePoints)
    const zone2 = type === ClimbigEventType.CUSTOM && !!event.zone2Points
    const routeStatus = [
        {
            status: UserRouteStatus.NOTHING,
            label: "X",
            color: "#F3EFEB",
            icon: ClearIcon,
        }
    ]
    if (zone) {
        routeStatus.push({
            status: UserRouteStatus.ZONE,
            label: "ZONA",
            color: "#707B84",
            icon: LooksOneIcon,
        })
    }
    if (zone2) {
        routeStatus.push({
            status: UserRouteStatus.ZONE2,
            label: "ZONA 2",
            color: "#DAB893",
            icon: LooksTwoIcon,
        })
    }
    routeStatus.push(
        {
            status: UserRouteStatus.DONE,
            label: "TOP",
            color: "#222222",
            icon: DoneIcon,
        })

    if (flash) {
        routeStatus.push({
            status: UserRouteStatus.FLASH,
            label: "TOP FL",
            color: "#f1405c",
            icon: BoltIcon,
        })
    }
    return routeStatus
}
export type UserClimbingRoute = {
    id: number,
    status: UserRouteStatus,
}

export class UserClimbingEvent {
    constructor(
        public eventId: string,
        public eventType: ClimbigEventType,
        public userId: string,
        public name?: string,
        public email?: string,
        public birthYear: number = 0,
        public sex?: Sex,
        public climbingRoutes: UserClimbingRoute[] = [],
        public sumOfPoints: number = 0,
        public sumOfZones: number = 0,
        public category?: DifficultyCategory,
        public isSection: boolean = false,
        public section?: string,
        public competitionUserData?: CompetitionUserData,
        public bestRouteId?: number,
        public startNumber?: string,
        public nrOfEntry?: number,
        public nrOfClimbsOnHardest?: number,
    ) {

    }

}

export const getPointsForRoute = (route: UserClimbingRoute): number => {
    if (route.status === UserRouteStatus.ZONE) {
        return 1
    } else if (route.status === UserRouteStatus.FLASH) {
        return 4
    } else if (route.status === UserRouteStatus.DONE) {
        return 3
    }
    return 0
}

const calculatePointsForRoute = (route: UserClimbingRoute, event: ClimbingEvent): number => {
    let pointsExpresion = "0"
    if (route.status === UserRouteStatus.ZONE) {
        pointsExpresion = event.zonePoints || "0"
    } else if (route.status === UserRouteStatus.ZONE2) {
        pointsExpresion = event.zone2Points || "0"
    }
    if (route.status === UserRouteStatus.FLASH) {
        pointsExpresion = event.flashPoints || "0"
    } else if (route.status === UserRouteStatus.DONE) {
        pointsExpresion = event.donePoints || "0"
    } else if (route.status === UserRouteStatus.NOTHING) {
        pointsExpresion = event.nothingPoints || "0"
    }
    let expresionWithId = pointsExpresion.replace("n", route.id.toString());
    if (event.showGrade && pointsExpresion.includes("g")) {
        const dificulty = event.routes.find(r => route.id === r.id)?.dificulty || "";
        expresionWithId = expresionWithId.replace("g", dificulty)
    } else {
        expresionWithId = expresionWithId.replace("g", "0")
    }


    //eslint-disable-next-line
    return eval(expresionWithId)
}

export function updateRouteAndRecalculate(userEvent: UserClimbingEvent, event: ClimbingEvent, routeId: number, newStatus: UserRouteStatus): boolean {
    const route = event.routes.find(r => r.id === routeId)
    if (!route) {
        return false
    } else {
        const userRoute = userEvent.climbingRoutes.find(r => r.id === routeId)
        if (userRoute) {
            userRoute.status = newStatus
        } else {
            const newRoute: UserClimbingRoute = {id: routeId, status: newStatus}
            userEvent.climbingRoutes.push(newRoute)
        }
        recalculateScore(userEvent, event)
        return true
    }
}

function getRoutesForUser(userEvent: UserClimbingEvent, event: ClimbingEvent) {
    if (event.showGrade) {
        return userEvent.climbingRoutes
    }
    return userEvent.climbingRoutes
        .filter(route => event.routes.find(r => r.id === route.id)?.dificulty === FOR_ALL || event.routes.find(r => r.id === route.id)?.dificulty === userEvent.category);
}

export const recalculateScore = (userEvent: UserClimbingEvent, event: ClimbingEvent): void => {

    if (event.type === ClimbigEventType.FLASH) {
        userEvent.sumOfPoints = userEvent.climbingRoutes
            .filter(route => isDone(route.status))
            .filter(route => event.routes.find(r => r.id === route.id)?.dificulty === FOR_ALL || event.routes.find(r => r.id === route.id)?.dificulty === userEvent.category)
            .sort((a, b) => a.id - b.id)
            .slice(-20)
            .reduce((sum, route) => sum + (route.id * 2) + (route.status === UserRouteStatus.FLASH ? 1 : 0), 0)
    } else if (event.type === ClimbigEventType.SIMPLE) {
        userEvent.sumOfPoints = userEvent.climbingRoutes.filter(route => isDone(route.status))
            .filter(route => event.routes.find(r => r.id === route.id)?.dificulty === FOR_ALL || event.routes.find(r => r.id === route.id)?.dificulty === userEvent.category)
            .sort((a, b) => a.id - b.id)
            .slice(-20)
            .reduce((sum, route) => sum + route.id, 0)
    } else if (event.type === ClimbigEventType.FLASH_ZONE) {
        userEvent.sumOfPoints = userEvent.climbingRoutes
            .filter(route => event.routes.find(r => r.id === route.id)?.dificulty === FOR_ALL || event.routes.find(r => r.id === route.id)?.dificulty === userEvent.category)
            .map(route => getPointsForRoute(route)).reduce((sum, value) => sum + value, 0)
    } else if (event.type === ClimbigEventType.CUSTOM) {
        if (event.separateZonePoint) {
            userEvent.sumOfPoints = getRoutesForUser(userEvent, event)
                .filter(route => route.status !== UserRouteStatus.ZONE)
                .map(route => calculatePointsForRoute(route, event))
                .reduce((sum, value) => sum + value, 0)
            userEvent.sumOfZones = getRoutesForUser(userEvent, event)
                .filter(route => route.status === UserRouteStatus.ZONE)
                .map(route => calculatePointsForRoute(route, event))
                .reduce((sum, value) => sum + value, 0)

        } else if(event.separateFlashPoint) {
            userEvent.sumOfPoints = getRoutesForUser(userEvent, event)
                .filter(route => route.status !== UserRouteStatus.FLASH)
                .map(route => calculatePointsForRoute(route, event))
                .reduce((sum, value) => sum + value, 0)
            userEvent.sumOfZones = getRoutesForUser(userEvent, event)
                .filter(route => route.status === UserRouteStatus.FLASH)
                .map(route => calculatePointsForRoute(route, event))
                .reduce((sum, value) => sum + value, 0)
        }else{
            userEvent.sumOfPoints = userEvent.sumOfPoints = getRoutesForUser(userEvent, event)
                .map(route => calculatePointsForRoute(route, event))
                .sort((a, b) => a - b)
                .slice(-(event.limit || 0))
                .reduce((sum, value) => sum + value, 0)
        }
    } else {
        userEvent.sumOfPoints = userEvent.climbingRoutes.reduce((sum, route) => sum + (isDone(route.status) ? 1 : 0), 0)
    }
}
export type CompetitionUserData = {
    sponsorName: string,
    group?: ClimbingEventGroup,
    city: string,
}
